import { render } from "./bzyx.vue?vue&type=template&id=86de8d0a&scoped=true"
import script from "./bzyx.vue?vue&type=script&lang=js"
export * from "./bzyx.vue?vue&type=script&lang=js"

import "./bzyx.vue?vue&type=style&index=0&id=86de8d0a&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86de8d0a"]])

export default __exports__